import { render, staticRenderFns } from "./setup-hik-dlysjg-sms-modal.vue?vue&type=template&id=04f813c4"
import script from "./setup-hik-dlysjg-sms-modal.vue?vue&type=script&lang=js"
export * from "./setup-hik-dlysjg-sms-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports